import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/share';
import { UrlManagerService } from './url-manager.service';
import { Router } from '@angular/router';

@Injectable()
export class InventoryService {

  constructor(private http: Http, private UrlManager: UrlManagerService, private router: Router) {
  }

  getRequiredBooks() {
    var Obserable = this.http.get(this.UrlManager.getApiUrl() + "/tools/v1/books/required", this.UrlManager.getOptions()).map(res => res.json());
    Obserable.subscribe((res) => { }, (error) => {
      if (error.status != 200) {
        console.log(error);
        this.router.navigate(['home']);
      }
    });
    return Obserable;
  }

  // getDonnatedBooks() {
  //   var Obserable = this.http.get(this.UrlManager.getApiUrl() + "/inventory/books", this.UrlManager.getOptions()).map(res => res.json());
  //   Obserable.subscribe((res) => { }, (error) => {
  //     if (error.status != 200) {
  //       console.log(error);
  //       this.router.navigate(['home']);
  //     }
  //   });
  //   return Obserable;
  // }
  getRequiredBikes() {
    var Obserable = this.http.get(this.UrlManager.getApiUrl() + "/inventory/bike/required", this.UrlManager.getOptions()).map(res => res.json());
    Obserable.subscribe((res) => { }, (error) => {
      if (error.status != 200) {
        console.log(error);
        this.router.navigate(['home']);
      }
    });
    return Obserable;
  }

  getDonnatedBikes() {
    var Obserable = this.http.get(this.UrlManager.getApiUrl() + "/inventory/bike", this.UrlManager.getOptions()).map(res => res.json());
    Obserable.subscribe((res) => { }, (error) => {
      if (error.status != 200) {
        console.log(error);
        this.router.navigate(['home']);
      }
    });
    return Obserable;
  }
  
}


// WEBPACK FOOTER //
// ./src/app/Services/inventory.service.ts